import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 140B0E5A-4F75-4C53-A9D5-867E4DC020E7
 * name bookmark-music-outline
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bookmark-music-outline.svg
 * tags
 * - Music 
 */
export const BookmarkMusicOutlineIcon = createSvgIcon(<><path d="M7 3C5.9 3 5 3.9 5 5V21L12 18L19 21V5C19 3.89 18.1 3 17 3H7M7 5H17V18L12 15.82L7 18V5M12 6V11.3C11.7 11.1 11.4 11 11 11C9.9 11 9 11.9 9 13C9 14.11 9.9 15 11 15C12.11 15 13 14.11 13 13V8H15V6H12Z" /></>, 'BookmarkMusicOutlineIcon');
export default BookmarkMusicOutlineIcon